import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { HelpCircle, X, Loader2, Bot } from "lucide-react";

export function CoPilotFieldHelp({ stepKey }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchHelp = async () => {
    if (data) { setOpen(true); return; }
    setOpen(true);
    setLoading(true);
    try {
      const res = await api.get(`/space-engine/copilot/field-help/${stepKey}`);
      setData(res.data);
    } catch {
      setData({ title: stepKey, help: "Hindi ma-load ang help info ngayon. Try ulit mamaya!" });
    }
    setLoading(false);
  };

  return (
    <>
      <Button variant="ghost" size="sm" onClick={fetchHelp} className="h-7 px-2 gap-1 text-blue-600 hover:text-blue-700 hover:bg-blue-50" data-testid={`copilot-help-${stepKey}`}>
        <Bot className="w-3.5 h-3.5" />
        <span className="text-[10px] font-heading uppercase tracking-wider">CoPilot Help</span>
      </Button>

      {open && (
        <div className="mt-3 bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 relative" data-testid={`copilot-help-panel-${stepKey}`}>
          <button onClick={() => setOpen(false)} className="absolute top-2 right-2 text-muted-foreground hover:text-foreground">
            <X className="w-4 h-4" />
          </button>
          {loading ? (
            <div className="flex items-center gap-2 py-2">
              <Loader2 className="w-4 h-4 animate-spin text-blue-600" />
              <span className="text-sm text-blue-700">Loading CoPilot help...</span>
            </div>
          ) : data ? (
            <div>
              <div className="flex items-center gap-2 mb-2">
                <Bot className="w-4 h-4 text-blue-600" />
                <h4 className="font-heading font-bold text-sm text-blue-900">{data.title}</h4>
              </div>
              <div className="text-sm text-blue-800 leading-relaxed whitespace-pre-line prose prose-sm max-w-none">
                {data.help.split('\n').map((line, i) => {
                  if (line.startsWith('**') && line.includes('**')) {
                    const parts = line.split('**');
                    return <p key={i} className="mb-1">{parts.map((p, j) => j % 2 === 1 ? <strong key={j}>{p}</strong> : p)}</p>;
                  }
                  if (line.startsWith('•') || line.startsWith('-')) {
                    return <p key={i} className="ml-3 mb-0.5">{line}</p>;
                  }
                  if (line.startsWith('Tip:') || line.startsWith('Important:')) {
                    return <p key={i} className="mt-2 p-2 bg-amber-50 border border-amber-200 rounded text-amber-800 text-xs">{line}</p>;
                  }
                  return line ? <p key={i} className="mb-1">{line}</p> : <br key={i} />;
                })}
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
}
